import * as React from 'react'
import styled from 'styled-components'

type TProps = {
  type?: 'search' | 'home'
}

const ChannelCardLoading: React.FC<TProps> = ({ type = 'home' }) => {
  return (
    <StyledWrapper data-type={type}>
      <div className="lt">
        <div className="img-box" />
        <div className="lt-content">
          <div className="follow-card-title"></div>
          <div className="follow-card-subtitle"></div>
        </div>
      </div>
      <div className="btn"></div>
    </StyledWrapper>
  )
}

export default ChannelCardLoading

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .lt {
    display: flex;
    gap: 10px;
    .img-box {
      width: 43px;
      height: 43px;
      background-color: #eee;
      border-radius: 5px;
    }
    .lt-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .follow-card-title {
        height: 16px;
        width: 70px;
        background-color: #eee;
        border-radius: 5px;
        margin-bottom: 3px;
      }
      .follow-card-subtitle {
        height: 12px;
        width: 80px;
        background-color: #eee;
        border-radius: 5px;
      }
    }
  }
  .btn {
    height: 34px;
    width: 70px;
    background-color: #eee;
    border-radius: 5px;
    margin-bottom: 3px;
  }
  &[data-type='search'] {
    padding: 20px 0;
    .lt {
      gap: 24px;
      .img-box {
        width: 66px;
        height: 66px;
      }
      .content-box-subtitle {
        color: #333;
      }
    }
  }
`
